import { render, staticRenderFns } from "./communitySpaceConfirmList.vue?vue&type=template&id=23bd25ae&scoped=true"
import script from "./communitySpaceConfirmList.vue?vue&type=script&lang=js"
export * from "./communitySpaceConfirmList.vue?vue&type=script&lang=js"
import style0 from "./communitySpaceConfirmList.vue?vue&type=style&index=0&id=23bd25ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd25ae",
  null
  
)

export default component.exports